import { Component, HostBinding } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SideBarComponent } from '../shared/sidebar/side-bar-component';
import { SideBarService } from '../shared/sidebar/side-bar.service';

@Component({
  selector: 'app-linge-hebergement',
  templateUrl: './linge-hebergement.component.html',
  styleUrls: ['./linge-hebergement.component.scss']
})
export class LingeHebergementComponent extends SideBarComponent {
  @HostBinding('class.clamp') clamp = true;

  constructor(
    protected sideBar: SideBarService,
    protected router: Router,
    protected route: ActivatedRoute
  ) {
    super(sideBar, router, route);
  }

  ngOnInit() {
  }

}
